



























import Vue from "vue";
import { gameStore } from "@/store/game/store";
import { Client } from "@/client";
import { Action } from "@/store/game";
export default Vue.extend({
  computed: {
    glasses() {
      return gameStore.state.playersGlasses[gameStore.state.playerInfo.id];
    },
    needGlass() {
      return gameStore.state.ui.needGlass;
    },
    nextTurnVisible(): boolean {
      return (
        !gameStore.state.gameEnded &&
        this.myTurn &&
        !gameStore.state.ui.needGlass &&
        gameStore.state.playersGlasses[gameStore.state.playerInfo.id] == 0
      );
    },
    myTurn() {
      return gameStore.state.currentPlayerId == gameStore.state.playerInfo.id;
    }
  },
  methods: {
    nextTurn() {
      Client.getInstance().send({
        action: Action.nextTurn
      });
    }
  }
});
